import { SupportTicketMapper } from '../SupportTicketMapper.js';
import { SupportTicketClaimDataMapper } from '../SupportTicketClaimData/SupportTicketClaimDataMapper.js';
import { SupportTicketAttachmentDetailsMapper } from '../SupportTicketAttachmentDetails/SupportTicketAttachmentDetailsMapper.js';

/**
 * Plain object Packlink's API response representation.
 */

class DamageSupportTicketMapper {
  static createModelFromResponse(response) {
    return {
      ...SupportTicketMapper.createModelFromResponse(response),
      ...SupportTicketClaimDataMapper.createModelFromResponse(response.damage),
      shipmentReference: response.shipment_reference,
      proofOfDamageExternalPackaging: response.damage.proof_of_damage_external_packaging,
      proofOfDamageExternalPackagingAttachmentDetail: SupportTicketAttachmentDetailsMapper.createModelFromResponse(response.damage.proof_of_damage_external_packaging_attachment_detail),
      proofOfDamageGoods: response.damage.proof_of_damage_goods,
      proofOfDamageGoodsAttachmentDetail: SupportTicketAttachmentDetailsMapper.createModelFromResponse(response.damage.proof_of_damage_goods_attachment_detail),
      proofOfDamageInternalPackaging: response.damage.proof_of_damage_internal_packaging,
      proofOfDamageInternalPackagingAttachmentDetail: SupportTicketAttachmentDetailsMapper.createModelFromResponse(response.damage.proof_of_damage_internal_packaging_attachment_detail)
    };
  }
  static createApiPayload(_ref) {
    let {
      shipmentReference,
      amount,
      proofOfValue,
      proofOfDamageExternalPackaging,
      proofOfDamageGoods,
      proofOfDamageInternalPackaging,
      productDescription,
      paymentMethod
    } = _ref;
    return {
      shipment_reference: shipmentReference,
      damage: {
        ...SupportTicketClaimDataMapper.createApiPayload({
          amount,
          proofOfValue,
          productDescription,
          paymentMethod
        }),
        proof_of_damage_external_packaging: proofOfDamageExternalPackaging,
        proof_of_damage_goods: proofOfDamageGoods,
        proof_of_damage_internal_packaging: proofOfDamageInternalPackaging
      }
    };
  }
}

export { DamageSupportTicketMapper };
//# sourceMappingURL=DamageSupportTicketMapper.js.map
